
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class FormRevisionsCard extends Vue {
    @Prop() form: any
    @Prop() revisions!: any[]

    viewMore = false

    get visibleRevisions() {
        return this.viewMore ? this.revisions : this.revisions.slice(0, this.visibleRevisionCount)
    }

    get visibleRevisionCount() {
        let count = this.revisions.find((revision) => revision._status === 'active') ? 1 : 0
        if (this.revisions.find((revision) => revision._status === 'draft')) count++
        if (count === 0 && this.revisions.length > 0) count++
        return count
    }

    getRevisionTitles(title: Record<string, string>) {
        let titles = ''
        Object.keys(title).forEach((language, index, array) => {
            titles += title[language] + (index === array.length - 1 ? '' : '\n')
        })
        return titles
    }
}
